RESPONSE_ERROR_TYPE_RANGE_400